
import React from 'react';
import ReactDOM from 'react-dom';
import '../../../../../styles/actionMenuRenderer.scss';

class CampaignDetailsActionMenuRenderer extends React.Component {
    constructor(props) {
        super(props);
        this.state = { position: { top: 0, left: 0 } };
        this.buttonRef = React.createRef();
        this.menuRef = React.createRef();
        this.menuContainer = document.createElement('div');
        this.menuContainer.className = 'dropdown-portal-container';
        this.isMenuContainerAppended = false;
    }

    componentDidMount() {
        if (!this.isMenuContainerAppended) {
            document.body.appendChild(this.menuContainer);
            this.isMenuContainerAppended = true;
        }
        document.addEventListener('click', this.handleOutsideClick);
        document.addEventListener('scroll', this.handleOutsideClick, true);
    }

    componentWillUnmount() {
        if (this.isMenuContainerAppended) {
            document.body.removeChild(this.menuContainer);
            this.isMenuContainerAppended = false;
        }
        document.removeEventListener('click', this.handleOutsideClick);
        document.removeEventListener('scroll', this.handleOutsideClick, true);
    }

    handleOutsideClick = (e) => {
        // Only handle clicks if this specific instance's menu is open
        if (!this.props.isOpen) {
            return;
        }

        // ✅ Skip if click inside menu or button
        if (this.buttonRef.current?.contains(e.target) || this.menuRef.current?.contains(e.target)) {
            return;
        }

        this.props.onToggle(null);
    };

    getMenuHeight = () => {
        // If menu is currently rendered and ref exists, get actual height
        if (this.menuRef.current) {
            return this.menuRef.current.offsetHeight;
        }
        // Fallback: estimate based on number of menu items
        const baseHeight = 60;
        const itemHeight = 48;
        const itemCount = 5;

        return baseHeight + (itemCount * itemHeight);
    };

    toggleMenu = (e) => {
        e.stopPropagation();
        const rect = this.buttonRef.current.getBoundingClientRect();
        const menuHeight = this.getMenuHeight();
        const viewportHeight = window.innerHeight;
        const spaceBelow = viewportHeight - rect.bottom;
        const spaceAbove = rect.top;

        // Position above if there's not enough space below and there's more space above
        const shouldPositionAbove = spaceBelow < menuHeight && spaceAbove > spaceBelow;

        const newPosition = {
            top: shouldPositionAbove
                ? rect.top + window.scrollY - menuHeight + 65
                : rect.bottom + window.scrollY,
            left: rect.left + window.scrollX + 60,
        };

        this.setState({
            position: newPosition,
        });

        this.props.onToggle(this.props.campaign?.id); // notify parent
    };

    editName = (campaign, event) => {
        this.props.handleDescriptionClick(campaign);
        this.toggleMenu(event);
    }

    syncMediaOrderToPrisma = (campaign, event) => {
        this.props.handleSyncToPrismaClick(campaign);
        this.toggleMenu(event);
    }

    editPlannedChannels = (campaign, event) => {
        this.props.handlePlannedChannelsClick(campaign);
        this.toggleMenu(event);
    }

    renderMenu() {
        const { top, left } = this.state.position;
        if (!this.props.isOpen) return null;

        return ReactDOM.createPortal(
            <div className="action-dropdown-portal-menu campaign-details-actions-menu" style={{ top, left, position: 'absolute', zIndex: 9999 }} ref={this.menuRef}>
                <div className="dropdown-content-actions">
                    <div className="action-card">
                        <div className='menu-item' style={{ cursor: 'pointer' }} onClick={(e) => { this.props.navigateToPlacementDetails(); }}>
                            <span>Open placements</span>
                        </div>
                        <div className='menu-item' style={{ cursor: 'pointer' }} onClick={(e) => { this.toggleMenu(e); this.props.onCopyPlacements && this.props.onCopyPlacements(this.props.campaign); }}>
                            <span>Copy Placements</span>
                        </div>
                        <div className='menu-item' style={{ cursor: 'pointer' }} onClick={(e) => { this.toggleMenu(e); this.props.handleMediaOrderClick(this.props.campaign); }}>
                            <span>See more info</span>
                        </div>
                        <div className='menu-item' style={{ cursor: 'pointer' }} onClick={(e) => { this.editName(this.props.campaign, e); }}>
                            <span>Edit campaign name</span>
                        </div>
                        <div className='menu-item' style={{ cursor: 'pointer' }} onClick={(e) => { this.editPlannedChannels(this.props.campaign, e); }}>
                            <span>Edit planned channels</span>
                        </div>
                        <div className='menu-item' style={{ cursor: 'pointer' }} onClick={(e) => { this.syncMediaOrderToPrisma(this.props.campaign, e); }}>
                            <span>Sync media order to Prisma</span>
                        </div>
                    </div>
                </div>
            </div>,
            this.menuContainer
        );
    }

    render() {
        return (
            <>
                <button type='button' slot="invoker" aria-haspopup="true" className="icon medium" ref={this.buttonRef} onClick={this.toggleMenu}>
                    <omni-icon icon-id="omni:interactive:actions"></omni-icon>
                </button>

                {this.renderMenu()}
            </>
        );
    }
}

export default CampaignDetailsActionMenuRenderer;
